<template>
  <div
    class="modal fade"
    id="approvalWaveStatusModal"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>
          <h4 class="modal-title">
            <b>{{ lang.AWS000 }}</b>
          </h4>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label class="col-md-2 control-label"
              >{{ lang.AWS001 }} / {{ lang.AWS002 }}</label
            >
            <div class="col-md-5">
              <select2
                id="approval-wave-status-project-select"
                class="form-control"
                v-model="selectedProject"
                :placeholder="lang.AWS003"
                :allowClear="true"
                :afterChange="(selectedWave = '')"
              >
                <option></option>
                <option
                  v-for="project in projectsWaves"
                  :key="project.ProjectGuid"
                  :value="project.ProjectGuid"
                >
                  {{ project.ProjectName }}
                </option>
              </select2>
            </div>
            <div class="col-md-5">
              <select2
                id="approval-wave-status-wave-select"
                class="form-control"
                v-model="selectedWave"
                ref="waveSelect"
                :placeholder="lang.AWS004"
                :allowClear="true"
                :disabled="!selectedProject"
                :afterChange="getWaveStatus()"
              >
                <option></option>
                <option
                  v-for="wave in availableWaves"
                  :key="wave.WaveGuid"
                  :value="wave.WaveGuid"
                >
                  {{ wave.WaveName }}
                </option>
              </select2>
            </div>
          </div>

          <div class="table-container">
            <table
              class="table outer-table"
              v-if="selectedWave && statusData.SurveyInstances"
            >
              <thead>
                <tr>
                  <th class="nopadding noborder" style="width: 30%"></th>
                  <th class="nopadding noborder" style="width: 70%"></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-if="
                    statusData.SurveyInstances &&
                    statusData.SurveyInstances.Status
                  "
                >
                  <td class="text-left noborder">
                    <b>{{ lang.AWS005 }}</b>
                  </td>
                  <td class="text-left noborder">
                    <table class="table table-hover" style="width: 66.67%">
                      <tbody>
                        <tr>
                          <td>{{ lang.AWS006 }}</td>
                          <td>{{ statusData.SurveyInstances.Status.Count }}</td>
                        </tr>
                        <tr>
                          <td>{{ lang.AWS007 }}</td>
                          <td>
                            {{ statusData.SurveyInstances.Status.Approval }}
                          </td>
                        </tr>
                        <tr>
                          <td>{{ lang.AWS008 }}</td>
                          <td>
                            {{ statusData.SurveyInstances.Status.InProgress }}
                          </td>
                        </tr>
                        <tr>
                          <td>{{ lang.AWS009 }}</td>
                          <td>
                            {{ statusData.SurveyInstances.Status.Reporting }}
                          </td>
                        </tr>
                        <tr v-if="statusData.Wave">
                          <td>{{ lang.AWS010 }}</td>
                          <td>
                            {{
                              Number((statusData.Wave.InTime * 100).toFixed(2))
                            }}
                            %
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr v-if="statusData.Approvals">
                  <td class="text-left">
                    <b>{{ lang.AWS011 }}</b>
                  </td>
                  <td class="text-left">
                    <table class="table table-hover" style="width: 66.67%">
                      <tbody>
                        <tr>
                          <td>{{ lang.AWS012 }}</td>
                          <td>
                            {{
                              Number(
                                (statusData.Approvals.None * 100).toFixed(2)
                              )
                            }}
                            %
                          </td>
                        </tr>
                        <tr>
                          <td>{{ lang.AWS013 }}</td>
                          <td>
                            {{
                              Number(
                                (statusData.Approvals.Open * 100).toFixed(2)
                              )
                            }}
                            %
                          </td>
                        </tr>
                        <tr>
                          <td>{{ lang.AWS014 }}</td>
                          <td>
                            {{
                              Number(
                                (statusData.Approvals.Approved * 100).toFixed(2)
                              )
                            }}
                            %
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td class="text-left">
                    <b>{{ lang.AWS015 }}</b>
                  </td>
                  <td class="text-left">
                    <table class="table table-hover">
                      <tbody>
                        <tr v-if="statusData.Shopper.Gender">
                          <td>{{ lang.AWS016 }}</td>
                          <td>
                            <b>{{ lang.AWS017 }}:</b>
                            {{
                              Number(
                                (statusData.Shopper.Gender.Male * 100).toFixed(
                                  2
                                )
                              )
                            }}
                            %
                          </td>
                          <td>
                            <b>{{ lang.AWS018 }}:</b>
                            {{
                              Number(
                                (
                                  statusData.Shopper.Gender.Female * 100
                                ).toFixed(2)
                              )
                            }}
                            %
                          </td>
                          <td></td>
                        </tr>
                        <tr v-if="statusData.Shopper.Age">
                          <td>{{ lang.AWS019 }}</td>
                          <td>
                            <b>{{ lang.AWS020 }}:</b>
                            {{ statusData.Shopper.Age.Min }}
                          </td>
                          <td>
                            <b>{{ lang.AWS021 }}:</b>
                            {{ statusData.Shopper.Age.Max }}
                          </td>
                          <td>
                            <b>{{ lang.AWS022 }}:</b>
                            {{
                              Number(
                                (statusData.Shopper.Age.Above65 * 100).toFixed(
                                  2
                                )
                              )
                            }}
                            %
                          </td>
                        </tr>
                        <tr v-if="statusData.Shopper.Distance">
                          <td>{{ lang.AWS023 }}</td>
                          <td>
                            <b>{{ lang.AWS020 }}:</b>
                            {{
                              (statusData.Shopper.Distance.Min / 1000).toFixed(
                                0
                              )
                            }}
                            km
                          </td>
                          <td>
                            <b>{{ lang.AWS021 }}:</b>
                            {{
                              (statusData.Shopper.Distance.Max / 1000).toFixed(
                                0
                              )
                            }}
                            km
                          </td>
                          <td></td>
                        </tr>
                        <tr v-if="statusData.Shopper.Car">
                          <td>{{ lang.AWS024 }}</td>
                          <td>
                            <b>{{ lang.AWS020 }}:</b>
                            {{ statusData.Shopper.Car.YearOfBuild.Min }}
                          </td>
                          <td>
                            <b>{{ lang.AWS021 }}:</b>
                            {{ statusData.Shopper.Car.YearOfBuild.Max }}
                          </td>
                          <td></td>
                        </tr>
                        <tr v-if="statusData.Model">
                          <td>{{ lang.AWS025 }} (-|=|+)</td>
                          <td>
                            <b>{{ lang.AWS026 }}:</b>
                            {{
                              Number(
                                (statusData.Model.Downgrade * 100).toFixed(2)
                              )
                            }}
                            %
                          </td>
                          <td>
                            <b>{{ lang.AWS027 }}:</b>
                            {{
                              Number((statusData.Model.Match * 100).toFixed(2))
                            }}
                            %
                          </td>
                          <td>
                            <b>{{ lang.AWS028 }}:</b>
                            {{
                              Number(
                                (statusData.Model.Upgrade * 100).toFixed(2)
                              )
                            }}
                            %
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr v-if="statusData.CarDistribution">
                  <td class="text-left">
                    <b>{{ lang.AWS029 }}</b>
                  </td>
                  <td class="text-left">
                    <table class="table table-hover">
                      <thead>
                        <tr>
                          <th>{{ lang.AWS030 }}</th>
                          <th>{{ lang.AWS031 }}</th>
                          <th>{{ lang.AWS032 }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(model, index) in statusData.CarDistribution"
                          :key="index"
                        >
                          <td>{{ model.CarModelName }}</td>
                          <td>
                            {{ Number((model.SetValue * 100).toFixed(2)) }} %
                          </td>
                          <td>
                            {{ Number((model.ActualValue * 100).toFixed(2)) }} %
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr v-if="statusData.CompetitorCarDistribution">
                  <td class="text-left">
                    <b>{{ lang.AWS033 }}</b>
                  </td>
                  <td class="text-left">
                    <table class="table table-hover">
                      <thead>
                        <tr>
                          <th>{{ lang.AWS030 }}</th>
                          <th>{{ lang.AWS031 }}</th>
                          <th>{{ lang.AWS032 }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(
                            model, index
                          ) in statusData.CompetitorCarDistribution"
                          :key="index"
                        >
                          <td>{{ model.CompetitorCarModel }}</td>
                          <td>
                            {{ Number((model.SetValue * 100).toFixed(2)) }} %
                          </td>
                          <td>
                            {{ Number((model.ActualValue * 100).toFixed(2)) }} %
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-raised" data-dismiss="modal">
            {{ lang.AWS034 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from "../Tools/Select2";

export default {
  name: "ApprovalWaveStatusModal",
  components: {
    Select2,
  },
  data() {
    return {
      selectedProject: "",
      selectedWave: "",
      statusData: {},
      projectsWaves: [],
      lang: {
        AWS000: "Wave Status",
        AWS001: "Project",
        AWS002: "Wave",
        AWS003: "Please select a project...",
        AWS004: "Please select a wave...",
        AWS005: "Check Status",
        AWS006: "Total check count",
        AWS007: "In approval",
        AWS008: "In progress",
        AWS009: "In reporting",
        AWS010: "In time",
        AWS011: "Approvals",
        AWS012: "None",
        AWS013: "Open",
        AWS014: "Approved",
        AWS015: "Wave charactertistics",
        AWS016: "Gender",
        AWS017: "Male",
        AWS018: "Female",
        AWS019: "Age",
        AWS020: "Min",
        AWS021: "Max",
        AWS022: "Above 65",
        AWS023: "Distance",
        AWS024: "Reg. year shopper car",
        AWS025: "Model match",
        AWS026: "Downgrade",
        AWS027: "Match",
        AWS028: "Upgrade",
        AWS029: "Audi cars",
        AWS030: "Model",
        AWS031: "Target value",
        AWS032: "Current value",
        AWS033: "Competitor cars",
        AWS034: "Close",
        AWS035: "Wave status access failed",
      },
    };
  },
  computed: {
    availableWaves() {
      if (!this.projectsWaves[0]) return [];
      let project = _.find(
        this.projectsWaves,
        (p) => p.ProjectGuid === this.selectedProject
      );
      return project && project.Waves ? project.Waves : [];
    },
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    this.globals.getWaveList((data) => {
      this.projectsWaves = data;
    });

    this.globals.$off("showApprovalWaveStatus");
    this.globals.$on("showApprovalWaveStatus", (check) => {
      if (check.ProjectGuid && check.WaveGuid) {
        this.selectedProject = check.ProjectGuid;
        this.selectedWave = check.WaveGuid;
        this.$refs.waveSelect.updateValue();
      }
      this.getWaveStatus();
      this.openModal();
    });
  },
  methods: {
    openModal() {
      $("#approvalWaveStatusModal").modal("show");
    },
    closeModal() {
      $("#approvalWaveStatusModal").modal("hide");
    },
    getWaveStatus() {
      if (!this.selectedWave) return;
      let query = `api/ProjectWaves/${this.selectedWave}/AgencyStatus`;

      $.ajax({
        method: "GET",
        url: query,
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          if (data) this.statusData = data;
        },
        error: (error) => {
          console.error("Error on GET in getWaveStatus()");
          this.globals.showErrorSnackbar(this.lang.AWS035);
        },
      });
    },
  },
};
</script>

<style scoped>
.modal-lg {
  width: 1100px;
}
.table {
  border: 3px solid lightgray;
  border-radius: 10px;
  border-collapse: separate;
  overflow: hidden;
}
.outer-table {
  margin-top: 10px;
}
.table th,
.table td {
  padding: 5px;
}

.modal-body {
  padding: 0;
}
.noborder {
  border: none !important;
}

.table-container {
  max-height: calc(100vh - 220px);
  overflow: auto;
  margin: 10px 0;
  padding: 0 20px;
}
</style>



// WEBPACK FOOTER //
// ApprovalWaveStatusModal.vue?2e95ad9b